import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useRoe } from "./RoeLayout";
import PublicAcademicsPage from "@/components/PublicAcademicsPage";

export default function Academics() {
  const data = useRoe();
  const docs = data.academics || [];
  return (
    <div data-testid="roe-ac-wrap">
      <PageHero eyebrow="Academic Resources" title="Academics" />
      <PageBody>
        <PublicAcademicsPage docs={docs} theme="navy" testidPrefix="roe-ac" />
      </PageBody>
    </div>
  );
}
